import React from 'react'
import ProjectCard from '../../components/projectCard/ProjectCard'
import "./projects.css"
import { motion } from 'framer-motion'
import NextButton from "../../components/nextbutton/NextButton"
import Navbar from "../../components/nav/Navbar"
import Navbarmobile from "../../components/navbarmobile/Navbarmobile"
import NextButtonMobile from "../../components/nextButtonMobile/NextButtonMobile"
import { Link } from 'react-router-dom'
import { webdetailsdata } from '../../utils/webdetails'
const Projects = () => {
  return (
    <div className="projects">
      <Navbarmobile/>
      <Link to ="/contact">
        <NextButtonMobile/>
      </Link>
      <Link to ="/contact">
        <NextButton/>
      </Link>
      <Navbar/>
        <div className="projects-wrapper">
          <header className="projects-header">
            <motion.h1
              initial={{y: -200}}
              animate={{y: 0}}
              transition={{type: "spring", delay: 1.6}}
            >Projects</motion.h1>
            <motion.div
              initial={{x: "100vw"}}
              animate={{x: 0}}
              transition={{type: "spring", delay: 2}}
            >
              <p>Hello viewer, I am very excited for you to see some of the projects I have developed.</p>
              <p>Building fast and reliable web apps is what I do.</p>
            </motion.div>
          </header> 
          <div className="projectCards-container">
            {webdetailsdata.map((webdata)=>
              <ProjectCard key={webdata.key} webdata={webdata}/>
            )}
        </div>
        </div>
    </div>
  )
}

export default Projects